import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { RolesTypes } from "@app/pages/users/utils/helpers";
import useAuth from "./AuthContext";

type PermissionContextType = {
  isTechnical: boolean;
  isAdmin: boolean;
  isSuperAdmin: boolean;
};

const initialState: PermissionContextType = {
  isTechnical: false,
  isAdmin: false,
  isSuperAdmin: false,
};

export const PermissionContext =
  createContext<PermissionContextType>(initialState);

type Props = {
  children: ReactNode;
};

export function PermissionProvider({ children }: Props) {
  const { user } = useAuth();
  const [isAdministrative, setIsAdministrative] = useState<boolean>(false);
  const [isTechnical, setIsTechnical] = useState<boolean>(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(false);

  useEffect(() => {
    if (user) {
      setIsAdministrative(user.roles.includes(RolesTypes.ADMIN));
      setIsTechnical(user.roles.includes(RolesTypes.TECHNICAL));
      setIsSuperAdmin(user.roles.includes(RolesTypes.SUPER_ADMIN));
    }
  }, [user]);

  const value = {
    isSuperAdmin: isSuperAdmin,
    isAdmin: isAdministrative,
    isTechnical: isTechnical,
  };
  return (
    <PermissionContext.Provider value={value}>
      {children}
    </PermissionContext.Provider>
  );
}
const usePermission = () => useContext(PermissionContext);

export default usePermission;
